export const FETCH_PROVIDER_PANELS_PENDING = "providerPanels/fetchProviderPanels/pending";
export const FETCH_PROVIDER_PANELS_SUCCEEDED = "providerPanels/fetchProviderPanels/succeeded";
export const FETCH_PROVIDER_PANELS_FAILED = "providerPanels/fetchProviderPanels/failed";
export const UPDATE_PAGE_PARAMS = "providerPanels/pageParams/update";
export const UPDATE_FILTERS = "providerPanels/filters/update";
export const RESET_FILTERS = "providerPanels/filters/reset";
export const INITIALIZE_COMPONENT = "providerPanels/component/initialize";
